import { Auth } from 'aws-amplify'

let onMessageMap = {} // Stores symbols and their components' callbacks
let lastOnMessage = {}
let socket = null

export const SocketIOMixin = {
  data() {
    return {
      isManual: false,
      Mdata: null,
      subSymbols: [], // Store symbols this component has subscribed to
    }
  },
  methods: {
    async connectToSocket() {
      if (socket) {
        const isHealthy = socket.connected || socket.active
        if (isHealthy) return
        socket.close()
        socket = null
      }
      const io = require('socket.io-client')

      const socketUrl =
        process.env.VUE_APP_SOCKET_IO_URL ||
        'https://agtsocket-demo.eastus.cloudapp.azure.com'

      socket = io(socketUrl, {
        auth: async (cb) => {
          // Always invoke cb, even on failure: an uncaught rejection here never
          // reaches the handshake, so the client would hang instead of taking a
          // deterministic connect_error path. Send an empty token on failure so
          // the server rejects and connect_error fires.
          try {
            const session = await Auth.currentSession()
            cb({ token: session.getIdToken().getJwtToken() })
          } catch (e) {
            console.log('Socket IO auth failed', e)
            cb({ token: '' })
          }
        },
        reconnection: true,
      })

      // Capture the instance these handlers belong to. A later connectToSocket()
      // can close and replace the module-global `socket`, so handlers/timers
      // from a superseded instance must bail rather than act on the new one.
      const thisSocket = socket

      socket.on('message', (msg) => {
        if (onMessageMap[msg.symbol]) {
          lastOnMessage[msg.symbol] = msg
          onMessageMap[msg.symbol].forEach(({ callback }) => {
            try {
              callback(msg)
            } catch (e) {
              // fast clicking by users may trigger this error. safe to ignore
              console.log(e)
            }
          })
        }
      })

      socket.on('connect', () => {
        console.log('Socket IO Connected', socket)
        this.Resubscribe()
      })

      socket.on('connect_error', (err) => {
        if (thisSocket !== socket) return
        console.log('Socket IO connect_error', err.message)
        if (!thisSocket.active) {
          setTimeout(() => {
            if (thisSocket !== socket) return
            thisSocket.disconnect()
            thisSocket.connect()
          }, 2000)
        }
      })

      socket.on('disconnect', (reason) => {
        if (thisSocket !== socket) return
        console.log('Socket IO disconnected:', reason)
        if (reason === 'io server disconnect') {
          thisSocket.connect()
        }
      })
    },
    Resubscribe() {
      const symbols = Object.keys(onMessageMap)
      if (symbols.length && socket) {
        socket.emit('subscribe', symbols)
      }
    },
    subscribeSymbol(symbols, componentId, onMessage) {
      let newSymbols = []

      for (let symbol of symbols) {
        if (!onMessageMap[symbol]) {
          onMessageMap[symbol] = []
          newSymbols.push(symbol)
        }

        if (
          !onMessageMap[symbol].some(
            (entry) =>
              entry.callback.name.includes(onMessage.name) &&
              entry.componentId === componentId
          )
        ) {
          onMessageMap[symbol].push({ componentId, callback: onMessage })
        }

        if (lastOnMessage[symbol]) {
          try {
            onMessage(lastOnMessage[symbol])
          } catch (e) {
            // this can happen when user switches real fast and data is not there
            // usually safe to ignore
            console.log(e)
          }
        }
      }

      if (newSymbols.length) {
        socket.emit('subscribe', newSymbols)
      }
    },
    removeCbFromSymbolsMap(symbol, componentId, fnName) {
      const foundFnIndex = onMessageMap[symbol]?.findIndex(
        (fn) =>
          fn.callback.name.includes(fnName) && fn.componentId === componentId
      )
      if (foundFnIndex === -1) return

      onMessageMap[symbol]?.splice(foundFnIndex, 1)
      if (onMessageMap[symbol]) {
        this.unsubscribeSymbol([symbol], componentId)
      }
    },
    unsubscribeSymbol(symbols, componentId) {
      let toUnsubscribe = []

      for (let symbol of symbols) {
        if (onMessageMap[symbol]) {
          onMessageMap[symbol] = onMessageMap[symbol].filter((entry) => {
            const stored = String(entry.componentId || '')
            const id = String(componentId)
            // Match the exact id OR a delimiter-bounded prefix (`${id}_`).
            // Components subscribe with composite ids like `${_uid}_OptionChain`
            // but tear down with the bare `_uid`, so the bare id must still
            // clear those. The `_` boundary avoids the substring collision a
            // plain includes() caused (id "1" stripping "12", "10", etc.).
            return !(stored === id || stored.startsWith(`${id}_`))
          })

          if (onMessageMap[symbol].length === 0) {
            delete onMessageMap[symbol]
            toUnsubscribe.push(symbol)
          }
        }
      }

      if (toUnsubscribe.length && socket) {
        socket.emit('unsubscribe', toUnsubscribe)
      }
    },
    closeWS() {
      if (socket) {
        socket.close()
        socket = null
      }
    },
  },
  beforeDestroy() {
    //this.closeWS()
    this.unsubscribeSymbol(this.subSymbols, this._uid)
  },
}
